export { default } from './modal';
export type { ModalProps } from './modal';
